import {
  B_08,
  BANNER_DEFAULTS,
  hideB08Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";
import {
  URL_TYPE_OPTIONS,
  CATEGORY_HOME_LINK_TYPE,
  CATEGORY_PRODUCT_LISTING_LINK_TYPE,
  OTHER_LINK_TYPE,
  CATALOG_HOME_LINK_TYPE,
  EXTERNAL_LINK_TYPE,
} from "@stadium/shared/src/constants/stores/routes";

export const B08_PLASMIC_PROPS = {
  b08Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_08].heading,
    description: "Main heading (B08 only)",
    hidden: hideB08Props,
  },
  b08Description: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_08].description,
    description: "Description text (B08 only)",
    hidden: hideB08Props,
  },
  b08PrimaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_08].primaryButtonText,
    description: "Primary button text (B08 only)",
    hidden: hideB08Props,
  },
  b08PrimaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Primary button link type (B08 only)",
    hidden: hideB08Props,
  },
  b08PrimaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open primary button in new tab (B08 only)",
    hidden: hideB08Props,
  },
  b08PrimaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB08Props(props) ||
      (props.b08PrimaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.b08PrimaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b08PrimaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB08Props(props) ||
      (props.b08PrimaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b08PrimaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b08SecondaryButtonText: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_08].secondaryButtonText,
    description: "Secondary button text (B08 only)",
    hidden: hideB08Props,
  },
  b08SecondaryButtonLinkType: {
    type: "choice",
    options: URL_TYPE_OPTIONS,
    defaultValue: CATALOG_HOME_LINK_TYPE,
    description: "Secondary button link type (B08 only)",
    hidden: hideB08Props,
  },
  b08SecondaryButtonOpenInNewTab: {
    type: "boolean",
    defaultValue: false,
    description: "Open secondary button in new tab (B08 only)",
    hidden: hideB08Props,
  },
  b08SecondaryButtonOtherUrl: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB08Props(props) ||
      (props.b08SecondaryButtonLinkType !== OTHER_LINK_TYPE &&
        props.b08SecondaryButtonLinkType !== EXTERNAL_LINK_TYPE),
  },
  b08SecondaryButtonCategorySlug: {
    type: "string",
    defaultValue: "",
    hidden: (props) =>
      hideB08Props(props) ||
      (props.b08SecondaryButtonLinkType !== CATEGORY_HOME_LINK_TYPE &&
        props.b08SecondaryButtonLinkType !== CATEGORY_PRODUCT_LISTING_LINK_TYPE),
  },
  b08MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_08].mobileImg,
    description: "Mobile/tablet image (B08 only)",
    hidden: hideB08Props,
  },
  b08DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_08].desktopImg,
    description: "Desktop image (B08 only)",
    hidden: hideB08Props,
  },
  b08ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_08].imageAlt,
    description: "Image alt text (B08 only)",
    hidden: hideB08Props,
  },
};
